import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HtmlContent  from '@medscape-promo/medscapetv/html-content';

class TranscriptsContent extends Component {
    constructor(props){
        super(props);
        require('./transcripts-content.scss');
    }


    render(){
        let { content, imageServer } = this.props;
        if(content != null){
            const templateData = {
                imageServerHost: imageServer.host
            }
            return(
                <div className="content-wrapper">
                    <HtmlContent className="transcripts-content" content={content} templateData={templateData}/>
                </div>
            );
        }
        else{
            return null;
        }
    }
    static get propTypes() {
        return {
            content: PropTypes.string,
            imageServer: PropTypes.object
        }
    }
}


export default TranscriptsContent;